module.exports = __webpack_public_path__ + "static/media/main idea.c9b301eb.mp3";